var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fetch-worm-base',{key:"wormbase",attrs:{"id":_vm.wb_id},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var response = ref.response;
var loading = ref.loading;
return [(loading)?_c('div',[_vm._v("Loading...")]):(Object.keys(response).length > 0)?_c('div',[_vm._v(" "+_vm._s(_vm.goto(response.gene_name))+" ")]):_c('div',[_vm._v(" No record ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }